export const SUPPORTED_XLS_FORMATS = ['xls', 'xlsx', 'xlsm'];
